// extracted by mini-css-extract-plugin
module.exports = {"placeholderStyle":"Register_placeholderStyle__2-AXv","inputStyle":"Register_inputStyle__1QkJ-"};